/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Scanner_Scan_ResultsInputs */

const en_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

const de_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

const fr_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

const es_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

const it_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

const nl_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

const pl_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

const fi_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

const da_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

const sv_portal_scanner_scan_results = /** @type {(inputs: Portal_Scanner_Scan_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scan Results`)
};

/**
* | output |
* | --- |
* | "Scan Results" |
*
* @param {Portal_Scanner_Scan_ResultsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const portal_scanner_scan_results = /** @type {((inputs?: Portal_Scanner_Scan_ResultsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Scanner_Scan_ResultsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_portal_scanner_scan_results(inputs)
	if (locale === "fr") return fr_portal_scanner_scan_results(inputs)
	if (locale === "es") return es_portal_scanner_scan_results(inputs)
	if (locale === "it") return it_portal_scanner_scan_results(inputs)
	if (locale === "nl") return nl_portal_scanner_scan_results(inputs)
	if (locale === "pl") return pl_portal_scanner_scan_results(inputs)
	if (locale === "fi") return fi_portal_scanner_scan_results(inputs)
	if (locale === "da") return da_portal_scanner_scan_results(inputs)
	if (locale === "sv") return sv_portal_scanner_scan_results(inputs)
	return en_portal_scanner_scan_results(inputs)
});